import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-paragraph mb-0" }

import { onBeforeUnmount, onMounted, ref } from "vue";
import { EventBus, EventBusNames, type IConfirmationAlert } from "@/utils/EventBus";
import { toggleModal } from "@/utils/Helper";

const MODAL_ID = "confirmAlertModal";

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationAlert',
  setup(__props) {

const title = ref<string | null | undefined>(null);
const message = ref<string | null | undefined>(null);
let confirmCallback: () => void = () => {};
let cancelCallback: (() => void) | undefined;

const show = (data: IConfirmationAlert) => {
  confirmCallback = data.confirmCallback;
  cancelCallback = data.cancelCallback;
  title.value = data.title;
  message.value = data.message;
  toggleModal(MODAL_ID);
};
onMounted(() => EventBus.$on(EventBusNames.SHOW_CONFIRMATION_ALERT, show));
onBeforeUnmount(() => EventBus.$off(EventBusNames.SHOW_CONFIRMATION_ALERT, show));

function confirmAction() {
  confirmCallback();
  toggleModal(MODAL_ID);
}
function cancelAction() {
  cancelCallback?.();
  toggleModal(MODAL_ID);
}
// o X já fecha o modal (data-bs-dismiss); o legado chamava cancelAction e disparava o toggle de novo
const alertClosed = () => cancelCallback?.();

return (_ctx: any,_cache: any) => {
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, {
    title: title.value === null || title.value === undefined ? 'Confirmar ação' : title.value,
    id: "confirmAlertModal",
    "modal-class": "app-sheet text-primary",
    backdrop: "true",
    onModalClosed: alertClosed
  }, {
    body: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(message.value === null || message.value === undefined ? "Tem certeza que deseja continuar ?" : message.value), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", { class: "d-flex flex-column gap-3 w-100" }, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-app btn-app-outline",
          id: "confirm-alert-no",
          onClick: cancelAction
        }, "Não"),
        _createElementVNode("button", {
          type: "button",
          class: "btn-app btn-app-secondary",
          id: "confirm-alert-yes",
          onClick: confirmAction
        }, "Sim")
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})